import { CANCEL } from '@redux-saga/symbols';

function delayP(ms, val) {
  if (val === void 0) {
    val = true;
  }

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, ms, val);
  });

  promise[CANCEL] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

export default delayP;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@redux-saga/delay-p/dist/redux-saga-delay-p.esm.js
// module id = 390
// module chunks = 0